<template>
  <div>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="正在查询..."
      border
    >
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column
        label="消费单号"
        prop="ordersn"
        align="center"
      ></el-table-column>
      <el-table-column
        label="会员卡号"
        prop="card.card_num"
        align="center"
      ></el-table-column>
      <el-table-column label="手机号码" prop="user.mobile" align="center">
      </el-table-column>
      <el-table-column
        label="油品"
        prop="show_goodsname"
        align="center"
      ></el-table-column>
      <el-table-column label="升数" prop="num" align="center"></el-table-column>
      <el-table-column label="应收金额" prop="money"></el-table-column>
      <el-table-column label="实付金额" prop="amount" align="center">
        <template slot-scope="scope">
          <div>
            {{ scope.row.amount }}
            <el-button
              type="text"
              style="padding:0"
              @click="MoneyDetail(scope.row)"
              >详情</el-button
            >
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="手续费" prop="fee" align="center"></el-table-column> -->
      <el-table-column label="入账金额" align="center">
        <template slot-scope="scope">
          <span>{{
            (Number(scope.row.amount) - Number(scope.row.fee)).toFixed(2)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付方式" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.show_payway }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="下单时间"
        width="99px"
        prop="create_time"
        align="center"
      ></el-table-column>
      <el-table-column
        label="支付时间"
        width="99px"
        prop="show_payTime"
        align="center"
      ></el-table-column>
      <el-table-column
        label="作废时间"
        width="99px"
        prop="show_delTime"
        align="center"
      ></el-table-column>
      <el-table-column
        label="操作员"
        prop="show_empname"
        align="center"
      ></el-table-column>
      <el-table-column
        label="来源"
        prop="show_from"
        align="center"
      ></el-table-column>
    </el-table>
    <div style="margin-top:20px">
      <el-pagination
        layout="prev, pager, next, total"
        :current-page="page"
        :total="total"
        :page-size="10"
        background
        @current-change="getData"
      >
      </el-pagination>
    </div>
    <!-- 收款详情 -->
    <el-dialog
      :visible.sync="showMoneyDetail"
      @close="showMoneyDetail = false"
      title="收款详情"
      width="300px"
      append-to-body
    >
      <el-form :model="moneyDetailMsg" size="small" label-width="120px">
        <el-form-item label="原价">{{ moneyDetailMsg.money }}</el-form-item>
        <el-form-item label="会员优惠">{{
          moneyDetailMsg.dec_discount_money
        }}</el-form-item>
        <el-form-item label="优惠券优惠">{{
          moneyDetailMsg.dec_coupon_money
        }}</el-form-item>
        <el-form-item label="积分抵扣">{{
          moneyDetailMsg.dec_point_money
        }}</el-form-item>
        <el-form-item label="平台优惠">{{
            moneyDetailMsg.platform_discount||"0.00"
          }}</el-form-item>
        <el-form-item label="实际收款">{{
          moneyDetailMsg.amount
        }}</el-form-item>

        <div v-if="moneyDetailMsg.is_rounding">
          <el-form-item label="现金凑整">
            {{ moneyDetailMsg.numValue }}
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { cancelOrderList } from "@/api/vip";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  props: {
    allOrder: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      page: 1,
      total: 0,
      tableData: [],
      tableLoading: false,
      paywayList: [
        { id: "wxpay", name: "微信支付" },
        { id: "balance", name: "余额支付" },
        { id: "cash", name: "现金支付" },
        { id: "single_wxpay", name: "微信免签" },
        { id: "single_alipay", name: "支付宝免签" },
        { id: "unionpay", name: "银联支付" },
        { id: "card_balance", name: "加油卡支付" },
        { id: "allinpay", name: "通联支付" },
        { id: "family_balance", name: "亲属卡支付" },
        { id: "team_balance", name: "车队卡支付" },
        { id: "alipay", name: "支付宝支付" },
      ],
      showMoneyDetail: false, //显示价格详情
      moneyDetailMsg: {} // 价格详情
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(i) {
      this.tableLoading = true;
      if (i) {
        this.page = i;
      }
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      };
      cancelOrderList(data).then(res => {
        this.tableLoading = false;
        if (res.code == 200) {
          this.tableData = res.data;
          this.tableData.forEach(item => {
            item.show_goodsname = item.goods
              ? item.cate.name + " " + item.goods.name + item.type.name
              : "";
            item.show_from =
              item.source == "wx"
                ? "微信"
                : item.source == "h5"
                ? "支付宝"
                : item.source == "wxapp"
                ? "微信小程序"
                : item.source == "aliapp"
                ? "支付宝小程序"
                : item.source == "pos"
                ? "终端机"
                : item.source == "pc"
                ? "后台"
                : "";
            item.show_payTime = item.payment_time
              ? this.mydateFormat(item.payment_time)
              : "";
            item.show_delTime = item.delete_time
              ? this.mydateFormat(item.delete_time)
              : "";
            item.show_empname = item.emp == null ? "买单" : item.emp.name;
            item.show_payway = this.paywayList.find(
              x => x.id == item.payment_code
            ).name;
          });
          this.total = res.total;
        } else {
          this.$message(res.msg);
          this.tableData = [];
          this.total = 0;
        }
      });
    },
    // 收款详情
    MoneyDetail(data) {
      this.moneyDetailMsg = {
        money: data.money,
        dec_discount_money: data.dec_discount_money,
        dec_coupon_money: data.dec_coupon_money,
        dec_point_money: data.dec_point_money,
        amount: data.amount,
        platform_discount:data.platform_discount
      };
      let numValue =
        Number(data.money) -
        Number(data.dec_discount_money) -
        Number(data.dec_coupon_money) -
        Number(data.pay_discount) -
        Number(data.dec_point_money) -
        Number(data.amount);
      console.log("优惠金额", numValue);
      // this.moneyDetailMsg.is_rounding = true;
      // if (numValue == 0) {
      //   this.moneyDetailMsg.is_rounding = false;
      // } else if (numValue > 0) {
      //   this.moneyDetailMsg.roundTitle = "现金多收凑整";
      // } else if (numValue < 0) {
      //   this.moneyDetailMsg.roundTitle = "现金优惠凑整：";
      // }
      if (data.payment_code != "cash") {
        this.moneyDetailMsg.is_rounding = false;
      } else {
        this.moneyDetailMsg.is_rounding = true;
      }
      this.moneyDetailMsg.numValue = numValue.toFixed(2);
      this.showMoneyDetail = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.car_msg_box {
  display: flex;
  flex-wrap: wrap;
  .car_msg_item {
    width: 50%;
    line-height: 40px;
  }
}
</style>
